enum NFTInfoCardState {
    FullInfo = 1,
    Minimal = 2,
    Presentation = 3,
    NoNFT = 4
}

export { NFTInfoCardState }
